import { fetchSeoLinks } from '../../dataSource/seo/seo.request'
import { renderPage } from '../../domain/itinerary/itineraryHP.page'
import { isPagelessRoute } from '../../domain/router/routeUtils'
import { COUNT_CITIES_FOOTER_OTHER, FRONT_SERVICES_LINK_ITINERARY_HP } from '../../domain/seo/seo.constants'
import { resetAddress } from '../../store/address/addressSlice'
import { SEO_MODE_CAR } from '../../store/itinerary/itinerary.constants'
import { resetItinerary, resetItineraryExceptSteps, setStepIdx } from '../../store/itinerary/itinerarySlice'
import { activateGeoIp } from '../../store/map/mapSlice'
import { resetSearchTerms } from '../../store/search/searchSlice'
import { searchFirstCities } from '../../store/seo/seo-address.actions'
import { loadSeoItineraryHPFaq } from '../../store/seo/seo-faq.actions'
import { loadSeoItinerarySummaryData } from '../../store/seo/seo-itinerary.actions'
import { selectSeoItineraryData } from '../../store/seo/seo.selectors'
import { setSeoItineraryData } from '../../store/seo/seoSlice'
import { isEmptyObj } from '../../utils/object'
import { handleRouteLoading } from '../routeService'

export function onRouteEnter({ store: { dispatch, getState } }) {
  if (__BROWSER__) resetItineraryState.apply(null, arguments)

  return Promise.all([
    dispatch(activateGeoIp()),
    dispatch(resetAddress()),
    dispatch(resetSearchTerms()),
    loadItineraryHomePageData()(dispatch, getState)
  ])
}

export const resetItineraryState = ({ store: { dispatch }, routeContext: { state, action, prevRoute, nextRoute } }) => {
  const { avoidReset, keepSteps } = state || {}

  if (avoidReset) {
    dispatch(setStepIdx(undefined))
  } else {
    if (
      keepSteps ||
      (action === 'POP' && isPagelessRoute(prevRoute.route)) ||
      (action === 'REPLACE' && prevRoute.route === nextRoute.route)
    ) {
      dispatch(resetItineraryExceptSteps())
    } else {
      dispatch(resetItinerary())
    }
  }
}

const loadItineraryHomePageData = () => (dispatch, getState) =>
  Promise.resolve().then(() => {
    if (__SERVER__) {
      loadSeoItinerarySummaryData()(dispatch, getState)
      return Promise.all([
        searchFirstCities({ limit: COUNT_CITIES_FOOTER_OTHER })(dispatch, getState),
        loadSeoItineraryHPFaq(SEO_MODE_CAR)(dispatch, getState)
      ])
    }
    if (__BROWSER__) {
      const noItinerarySeoData = isEmptyObj(selectSeoItineraryData(getState()))
      if (noItinerarySeoData) {
        return fetchSeoLinks(FRONT_SERVICES_LINK_ITINERARY_HP).then(data => {
          if (data) {
            dispatch(setSeoItineraryData(data))
          }
        })
      }
    }
  })

function onRouteLeave() {
  /*
  - supprimer les pois de la vde
   */
}

export default handleRouteLoading({ onRouteEnter, renderPage, onRouteLeave })
